import { ReactNode } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

type SliderProps = {
  children: ReactNode;
};

const SliderComponent = (props: SliderProps) => {
  const { children, ...rest } = props;
  return <Slider {...rest}>{children}</Slider>;
};

export default SliderComponent;
